module.exports = __webpack_public_path__ + "static/media/Jonathan Fong.f241517f.png";